<template>
  <div class="introduce" :class="{ bgc: !isWhite }">
    <div class="content" :class="{ 'vertical-layout': isVerticalLayout }">
      <!-- 图片和文本根据 isLeft 属性和屏幕宽度交替排列 -->
      <div class="img" v-if="shouldDisplayImgFirst">
        <img :src="img" alt="">
      </div>
      <div class="text">
        <strong>{{ title }}</strong>
        <p>{{ text }}</p>
      </div>
      <div class="img" v-if="!shouldDisplayImgFirst">
        <img :src="img" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Introduce",
  props: {
    title: {
      type: String,
    },
    text: {
      type: String,
    },
    isLeft: {
      type: Boolean,
      default: true,
    },
    isWhite: {
      type: Boolean,
      default: false,
    },
    img: {
      type: String,
    },
  },
  data() {
    return {
      screenWidth: window.innerWidth,
    };
  },
  computed: {
    isVerticalLayout() {
      return this.screenWidth <= 768;
    },
    shouldDisplayImgFirst() {
      return this.isLeft || this.isVerticalLayout;
    },
  },
  created() {
    window.addEventListener("resize", this.updateScreenWidth);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateScreenWidth);
  },
  methods: {
    updateScreenWidth() {
      this.screenWidth = window.innerWidth;
    },
  },
};
</script>

<style scoped>
.bgc {
  background-color: #eeeeee;
}

.introduce {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 549px;
  min-height: 300px; /* 设置最小高度以确保内容可见 */
}

.content {
  font-size: 14px;
  color: #666666;
  width: 100%; /* 宽度设为 100% */
  max-width: 1200px; /* 最大宽度为 1200px */
  height: 100%;
  display: flex;
  align-items: center;
}

.content.vertical-layout {
  flex-direction: column; /* 在小屏幕下采用垂直排列 */
}

.content img {
  height: 350px;
  width: 600px;
}

.img {
  margin-right: 50px;
}

strong {
  font-size: 25px;
  font-weight: bold;
}

.text {
  margin-right: 50px;
}

@media screen and (max-width: 768px) {
  .content {
    flex-direction: column; /* 在小屏幕下采用垂直排列 */
  }

  .content img {
    width: 100%; /* 图片宽度设为100%以适应小屏幕 */
    height: auto; /* 自动高度 */
    margin: 0; /* 移除图片的右侧外边距 */
    margin-bottom: 20px; /* 添加底部间距 */
  }
  .img {
  margin-right: 0;
  padding: 20px;
}
.text {
  margin-right: 0;
  padding: 20px;

}
}
</style>
